export interface MoveActivityScheduleData {
  name: string;
  schSequenceNbr: string;
}

export class MoveActivityData {
  constructor(public schedules: MoveActivityScheduleData[], public originalScheduleNumber: string) {}
}
